import React from "react";
import LogoWordmark from "./atoms/LogoWordmark";
import { useTheme } from "../context/ThemeContext";

export default function Footer({ nav }) {
  const { t } = useTheme();
  return (
    <footer style={{ borderTop: `0.5px solid ${t.border}`, background: t.bg2, padding: "26px 32px" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
        <LogoWordmark onClick={() => nav("home")} />
        <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
          {[
            ["Privacy", "privacy"],
            ["Terms", "terms"],
            ["Contact", "contact"],
            ["About", "about"],
          ].map(([label, page]) => (
            <a key={label} href={`/${page}`} onClick={(event) => { event.preventDefault(); nav(page); }} style={{ fontSize: 12, color: t.text2, textDecoration: "none" }}>
              {label}
            </a>
          ))}
          <p style={{ fontSize: 12, color: t.text3, margin: 0 }}>An initiative by Prism Labs</p>
          <p style={{ fontSize: 12, color: t.text3, margin: 0 }}>QuantSoc © 2026</p>
        </div>
      </div>
    </footer>
  );
}
